<template>
  <base-stat-item :metric="metric" label="Social engagement">
    <template v-slot:icon>
      <social-ad-engagement-icon></social-ad-engagement-icon>
    </template>
  </base-stat-item>
</template>
<script>
import BaseStatItem from './BaseStatItem.vue';
import SocialAdEngagementIcon from '../Icons/SocialAdEngagementIcon.vue';

export default {
  props: {
    metric: [String, Number]
  },
  components: {
    BaseStatItem,
    SocialAdEngagementIcon,
  },
};
</script>
